module.exports = __webpack_public_path__ + "img/1568881950.ad4a48d8.jpg";